import { Controller } from '@hotwired/stimulus';

// Briefly pulses the element to draw attention right after it connects,
// e.g. following a redirect after a value it reflects just changed.
// Defaults to Tailwind's animate-pulse; override with a `pulse` class
// (data-pulse-once-pulse-class) for a different animation.
export default class extends Controller {
  static classes = ['pulse'];
  static values = { duration: { type: Number, default: 2000 } };

  connect() {
    this.activeClass = this.hasPulseClass ? this.pulseClass : 'animate-pulse';
    this.element.classList.add(this.activeClass);
    this.timeout = setTimeout(
      () => this.element.classList.remove(this.activeClass),
      this.durationValue
    );
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
